export const INPUT_DELIMITER = new RegExp(/\r?\n/); // Handles Windows/Unix line endings.

export const OUTPUT_DELIMITER = '\r\n';
